import { render } from "./distributorstocks.vue?vue&type=template&id=22ab7c6b"
import script from "./distributorstocks.vue?vue&type=script&lang=js"
export * from "./distributorstocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__